import React, { useEffect, useState } from "react";
import CustomSelect from "../custom_select";
import { CustomButton } from "../custom_button";
import moment from "moment";
import { useSnackbar } from "notistack";

const CustomTimePicker = ({ onClickCancel, onClickSave }) => {
  const [selectedHour, setSelectedHour] = useState({});
  const [selectedMinute, setSelectedMinute] = useState({});
  const [selectedSecond, setSelectedSecond] = useState({});
  const [hoursOption, setHoursOption] = useState([]);
  const [minuteOption, setMinuteOption] = useState([]);
  const [secondOption, setSecondOption] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const mapper = () => {
    //map hours
    let arr = [];
    const hours = [...Array(24).keys()];
    hours?.map((obj) => {
      arr.push({
        value: obj,
        label: obj,
      });
    });
    setHoursOption(arr);
    //map minutes
    let arr1 = [];
    const minutes = [...Array(60).keys()];
    minutes.map((obj) => {
      arr1.push({
        value: obj,
        label: obj,
      });
    });
    setMinuteOption(arr1);
    //map seconds
    let arr2 = [];
    const seconds = [...Array(60).keys()];
    seconds.map((obj) => {
      arr2.push({
        value: obj,
        label: obj,
      });
    });
    setSecondOption(arr2);
  };

  useEffect(() => {
    mapper();
  }, []);

  return (
    <div>
      <div style={{ margin: 10, width: "258px" }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Select Hours
        </label>

        <CustomSelect
          value={selectedHour}
          options={hoursOption}
          onChange={(data) => {
            setSelectedHour(data);
          }}
          placeholder={"Select Hour"}
        />
      </div>
      <div style={{ margin: 10, width: "258px" }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Select Minutes
        </label>

        <CustomSelect
          value={selectedMinute}
          options={minuteOption}
          onChange={(data) => {
            setSelectedMinute(data);
          }}
          placeholder={"Select Minutes"}
        />
      </div>
      <div style={{ margin: 10, width: "258px" }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Select Seconds
        </label>

        <CustomSelect
          value={selectedSecond}
          options={secondOption}
          onChange={(data) => {
            setSelectedSecond(data);
          }}
          placeholder={"Select Seconds"}
        />
      </div>
      <div style={{ display: "flex" }}>
        <CustomButton
          title="Cancel"
          styles={{ background: "#38369C", margin: "10px" }}
          textStyles={{
            color: "#FDFDFD",
            fontWeight: "500",
            fontSize: "16px",
          }}
          onClick={onClickCancel}
        />
        <CustomButton
          title="Save"
          styles={{ background: "#38369C", marginLeft: "20px" }}
          textStyles={{
            color: "#FDFDFD",
            fontWeight: "500",
            fontSize: "16px",
          }}
          onClick={() => {
            onClickSave(
              selectedHour?.value,
              selectedMinute?.value,
              selectedSecond?.value
            );
          }}
        />
      </div>
    </div>
  );
};

const styles = {};

export default CustomTimePicker;
